export function Megaphone() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="63"
      height="65"
      viewBox="0 0 63 65"
      fill="none"
    >
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.027 36.5869H29.6118C24.9414 36.5869 21.1553 40.373 21.1553 45.0433L21.1553 52.9166C21.1553 59.3584 26.3775 64.5806 32.8194 64.5806C39.2612 64.5806 44.4834 59.3584 44.4834 52.9166V45.0433C44.4834 40.373 40.6973 36.5869 36.027 36.5869ZM29.6119 41.8362H36.0271C37.7987 41.8362 39.2348 43.2723 39.2348 45.0438V52.917C39.2348 56.46 36.3626 59.3322 32.8195 59.3322C29.2765 59.3322 26.4043 56.46 26.4043 52.917L26.4043 45.0438C26.4043 43.2723 27.8404 41.8362 29.6119 41.8362Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.78418 39.2118L58.3762 55.4036C60.6154 56.0558 62.854 54.3763 62.854 52.044V4.08358C62.854 1.62307 60.3816 -0.0690203 58.088 0.821709L2.78418 22.2989V39.2118Z"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        d="M2.78456 18.5078C4.19257 18.5078 5.34161 19.6166 5.40612 21.0087L5.40897 21.1322V40.3779C5.40897 41.8273 4.23398 43.0023 2.78456 43.0023C1.37656 43.0023 0.227522 41.8935 0.163013 40.5014L0.160156 40.3779V21.1322C0.160156 19.6828 1.33514 18.5078 2.78456 18.5078Z"
        fill="currentColor"
      />
    </svg>
  );
}
